<template>
    <div>
        <audio style="display:none;" id="menuSfxOpenIcons" src="sfx/icons_for_menu.mp3"></audio>
        <div :class="['pmFrame', isMenuActive==true ? 'active':'']" :style="getListCountStyle()">
            <!--
            <div class="pmTitle">
                <span>{{elementName}}</span>
            </div>        
            -->
            <div class="openBoxFx">                
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                <defs>
                    <linearGradient id="gradient" gradientTransform="rotate(45)">
                        <stop offset="0%" stop-color="#1178be" />
                        <stop offset="100%" stop-color="#18a0c2" />
                    </linearGradient>
                </defs>
                <rect x="0" y="0" rx="35" ry="35" :width="getFrameWidth()" height="70"
                    fill="none"
                    stroke-dasharray="1,3" stroke-width="1" stroke="url(#gradient)" />
            </svg>
        </div>

        <div :class="['pmButtons', isMenuActive==true ? 'active':'']">
            <ul :style="getListCountStyle()">
                <li v-for="(item,mindex) in elements" 
                    :key="mindex" 
                    :style="'--index:'+mindex"
                    @click="menuClicked(mindex)" 
                    :class="[selectedIndex==mindex ? 'active':'']">
                        <img class="iconImg" :src="getIconFile(item)">
                        <div class="light"><img src="/images/icons/item_light.png"></div>
                        <div class="touchFx"></div>
                        <div class="title">{{item.name}}</div>
                </li>
            </ul>
        </div>

    </div>
</template>
<script>

export default 
{
    name: "Proscreenmenu",
    props: {        
        elements:
        {
            default:null,
            type:Array
        }
    },
    data()
    {
        return {
            elementName:'Explore',
            _menuSfxOpenIcons:null,
            _menuSfx1:null,
            selectedIndex:0,
            isMenuActive:false,
            menuItems:[
                {icon:'/images/icons/menu_implant.png'},
                {icon:'/images/icons/menu_kit.png'},
                {icon:'/images/icons/menu_package.png'},
                {icon:'/images/icons/menu_part.png'},
                {icon:'/images/icons/menu_video.png'}
            ]
        }
    },
    created()
    {
    },
    mounted()
    {
        //this.initText(false);
        setTimeout(() => 
        {
            this.updateElementName(0);
            this._menuSfx1 = document.getElementById("menuSfx1");
            this._menuSfxOpenIcons = document.getElementById("menuSfxOpenIcons");            
            this.isMenuActive = true;//open the menu sequence 

        }, 300);

        setTimeout(() => {
            //this._menuSfxOpenIcons.play();
            //src="sfx/icons_for_menu.mp3"
            this.sfxPlay("Interface_3");
        }, 500);
    },
    watch:{
    },
    methods:
    {
        getFrameWidth()
        {
            //set the frame width for the svg element
            if(this.elements)
            {
                let fw = (this.elements.length * 60)+100;
                return fw;
            }
            return 0;
        },
        getListCountStyle()
        {
            if(this.elements)
            {
                return '--count:'+this.elements.length;
            }
        },
        getIconFile(element)
        {
            return '/images/icons/menu_'+element.type+'.png';
        },
        menuClicked(index)
        {
            this.sfxPlay("Interface_5");
            //this._menuSfx1.play();
            this.selectedIndex = index;
            this.$emit('onClick',index);   
            this.updateElementName(index);
        },
        updateElementName(index)
        {
            this.elementName = this.elements[index].name;//  "";//////////////////////////////
        }
    },
};
</script>

<style>
    /* footer menu element */ 
    .pmTitle
    {
        position: absolute;top: -25px;left: 0px;
        width: calc(60px * var(--count) + 100px);
        color: #4e9cdb;
        /* font-size: clamp(10px, 1.2vw, 14px); */
        font-size: 13px;
        text-align: center;
        height: 20px;
        overflow: hidden;
    }
    .pmFrame .pmTitle span
    {
        position: relative;
        top: 15px;
        opacity: 0;
        transition: all ease 0.7s;
        transition-delay: 1.2s;
    }
    .pmFrame.active .pmTitle span
    {
        opacity: 1;
        top: 0px;
    }


    .pmFrame
    {
        position: relative;top: 0px;left: 0px;
        width: calc(60px * var(--count) + 100px);
        height: 70px;
    }
    .pmFrame .openBoxFx
    {
        position: absolute;top: 0px;left: 0px;
        width: calc(60px * var(--count) + 100px);
        height: 70px;
        background-color: #82d2fd;
        opacity: 0.2;
        border-radius: 70px;
        transition: all 2s cubic-bezier(0.8, 0, 0.19, 1);
        clip-path: circle(5%);
    }
    .pmFrame.active .openBoxFx
    {
        clip-path: circle(100%);
        opacity: 0;
    }


    .pmFrame svg
    {
        position: absolute;top: 0px;left: 0px;
        width: calc(60px * var(--count) + 100px);
        height: 70px;
        clip-path: circle(5%);
        transition: all 2s cubic-bezier(0.8, 0, 0.19, 1);
        filter: brightness(300%);
    }
    .pmFrame.active svg
    {
        clip-path: circle(100%);
        filter: brightness(100%);
    }

    .pmButtons
    {
        position: absolute;top: 15px;left: 50px;
    }
    .pmButtons ul
    {
        width: calc(60px * var(--count));
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        list-style: none;
        margin: auto;
        align-items: center;
        margin:0px;
        padding: 0px;
    }
    .pmButtons li
    {
        width: 40px;
        height: 40px;
        position: relative;
        cursor: pointer;
        /* clip-path: circle(0%); */
        transition: all ease-in 0.4s;
        transition-delay: calc(0.8s + 0.07s * var(--index));
        opacity: 0;
    }
    .pmButtons.active li
    {
        /* clip-path: circle(100%); */
        opacity: 1;
    }


    .pmButtons li .light
    {
        position: absolute;
        width: 80px;
        height: 50px;
        top: 0px;
        left: -20px;
        opacity: 0;
        transition: all ease 0.4s;
    }
    .pmButtons li.active .light
    {
        opacity: 1;
    }
    .pmButtons li .light img
    {
        position: relative;
        width: 80px;
        height: 40px;
        top: 15px;        
    }

    .pmButtons li .iconImg
    {
        width: 40px;
        height: 40px;
        opacity: 0.6;
        transition: all ease 0.4s;        
        /* animation: iconsShowIn 1s ease 0s infinite direction forwards; */
        
    }

    .pmButtons li.active .iconImg
    {
        opacity: 1;        
    }

    @keyframes iconsShowIn {
        0% {
            filter: brightness(500%);
        }
        50% {            

        }
        100% {
            filter: brightness(0%);
        }
    }

    .pmButtons li .title
    {
        position: absolute;
        top: -35px;
        left: 20px;
        color: #4e9cdb;
        font-size: 13px;
        text-align: center;
        width: 200px;
        transform: translateX(-50%);
        display: none;        
        pointer-events: none;
    }
    .pmButtons li.active .title
    {
        display: block;
    }

    .pmButtons li .touchFx
    {
        position: absolute;
        width: 50px;
        height: 50px;
        top: -5px;
        left: -5px;
        border-radius: 70px;
        background-color:#84c1db;
        box-shadow: 0 0 20px 5px #48abe0;
        opacity: 0;
    }
    .pmButtons li.active .touchFx
    {
        animation: touchFxFrames 0.3s;
    }
    @keyframes touchFxFrames 
    {
        0% {opacity: 1;}
        100% {opacity: 0;}
    }
    @media only screen and (max-width: 800px) 
    {
        .pmFrame svg {
            display: none;
        }
        .pmTitle
        {
            display: none;
        }
    }
</style>